import { useSidebarStore } from "@";

/**
 * Function to toggle the visibility of the sidebar on mobile devices
 */
const ToggleSidebar = () => {
  const { toggleSidebar, setSidebarSizeToLarge } = useSidebarStore();

  const handleClick = () => {
    setSidebarSizeToLarge();
    toggleSidebar();
  };

  return (
    <button
      type="button"
      aria-expanded="true"
      aria-controls="sidebar"
      aria-label="فتح القائمة الجانبية"
      onClick={handleClick}
      id="toggleSidebarMobile"
      className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-2xl bg-white dark:bg-gray-900 text-gray-700 dark:text-gray-400 ring-1 ring-gray-100 dark:ring-gray-900 transition-all duration-200 hover:bg-purple-50 hover:text-purple-900 hover:ring-purple-200 active:scale-95 lg:hidden"
    >
      <svg
        className="h-6 w-6"
        fill="currentColor"
        viewBox="0 0 20 20"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h6a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
        />
      </svg>
    </button>
  );
};

export default ToggleSidebar;
